// extracted by mini-css-extract-plugin
module.exports = {"subTitle":"SectionSubtitle_subTitle__cb2ZX","lightSubTitle":"SectionSubtitle_lightSubTitle__18PAD"};